import { createClient, type SupabaseClient } from '@supabase/supabase-js';
import { requireSupabaseEnv } from './env';

let _client: SupabaseClient | null = null;

export function createSupabaseBrowserClient(): SupabaseClient {
  if (_client) return _client;
  const { url, anonKey } = requireSupabaseEnv();
  _client = createClient(url, anonKey, {
    auth: {
      persistSession: true,
      autoRefreshToken: true,
      detectSessionInUrl: true,
    },
  });
  return _client;
}
